import { Seq } from 'immutable'
export default function stubImmutableKeyedSeq() {
  return Seq.Keyed({})
}
